import NiceModal, {useModal} from '@ebay/nice-modal-react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {useRepresentants, useSocieteCommerciale} from '@/haligator-factory';
import {HaliRenderMany, useHalState} from '@synako/haligator';
import {CheckLoaded} from '@/containers/CheckLoaded';
import {Representant} from '@/domains/client/RepresentantsView';

export const ContactsModal = NiceModal.create(() => {
  const modal = useModal();
  const {t} = useTranslation();
  const societeCommercialeHook = useHalState(useSocieteCommerciale());
  const representantsHook = useHalState(useRepresentants());

  return (
    <Modal
      isOpen={modal.visible}
      onClose={modal.hide}
      isCentered
    >
      <ModalOverlay />
      <ModalContent
        borderRadius='lg'
        bg='white'
        mx={4}
      >
        <ModalHeader
          borderBottomWidth='1px'
          borderColor='gray.200'
          pb={3}
        >
          {t('menu.contacts')}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          py={6}
          px={{base: 4, sm: 6}}
        >
          <VStack
            spacing={6}
            align='stretch'
          >
            <CheckLoaded
              hook={representantsHook}
              render={() => (
                <CheckLoaded
                  hook={societeCommercialeHook}
                  render={() => (
                    <SimpleGrid
                      columns={{base: 1, md: 2}}
                      spacing={5}
                    >
                      <HaliRenderMany
                        many={useRepresentants().followAll('items')}
                        render={({data}) => {
                          let representant = data.filter(
                            (contact) =>
                              contact.tolede.en_tant_que === 'commercial',
                          );
                          if (representant.length === 0) {
                            representant = data.filter(
                              (contact) =>
                                contact.tolede.en_tant_que === 'televente',
                            );
                          }
                          return representant.map((contact) => (
                            <Representant
                              key={contact.id}
                              nom={`${contact.tolede.individu.prenom ?? ''} ${contact.tolede.individu.nom ?? ''}`}
                              src=''
                              email={contact.tolede.individu.email}
                              telephone={
                                contact.tolede.individu.telephone ??
                                t('contact.non_renseigne')
                              }
                              statut={t(
                                `contact.${contact.tolede.en_tant_que}`,
                              )}
                            />
                          ));
                        }}
                        fallback={() => (
                          <Text>{t('global.erreur_chargement')}</Text>
                        )}
                      />
                    </SimpleGrid>
                  )}
                />
              )}
            />
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
});

// eslint-disable-next-line react-refresh/only-export-components
export const showContactsModal = () => {
  NiceModal.show(ContactsModal);
};
